import { create } from 'zustand';
import type { DateSelection } from 'containers/Dashboard/types/dashboard.types';

interface DashboardStoreState {
  selectedDate: DateSelection;
  selectedDeviceGroups: number[];
  setSelectedDate: (selectedDate: DateSelection) => void;
  setSelectedDeviceGroups: (selectedDeviceGroups: number[]) => void;
  clearDashboards: () => void;
}

class EmptyDateSelection implements DateSelection {
  declare type: DateSelection['type'];
  declare resolution: DateSelection['resolution'];
  declare subDateModified: DateSelection['subDateModified'];
}

const INITIAL: Pick<
  DashboardStoreState,
  'selectedDate' | 'selectedDeviceGroups'
> = {
  selectedDate: { ...new EmptyDateSelection() },
  selectedDeviceGroups: [],
};

export const useDashboardStore = create<DashboardStoreState>((set) => ({
  ...INITIAL,
  setSelectedDate: (selectedDate) => set({ selectedDate }),
  setSelectedDeviceGroups: (selectedDeviceGroups) =>
    set({ selectedDeviceGroups }),
  clearDashboards: () => set({ ...INITIAL }),
}));

export const clearDashboardSelection = () =>
  useDashboardStore.getState().clearDashboards();
